import React from "react";
import "./ProgressBar.css"; // optional custom styles

const QuestionSetProgress = ({ answeredCount, totalQuestions }) => {
  const percentage =
    totalQuestions > 0 ? Math.round((answeredCount / totalQuestions) * 100) : 0;

  return (
    <div className="progress-container">
      <div className="progress-header">
        <span>填答進度</span>
        <span>
          {`${answeredCount}/${totalQuestions} (${percentage}%)`}
        </span>
      </div>
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      {/*<div className="progress-footer">{percentage}% completed</div>*/}
    </div>
  );
};

export default QuestionSetProgress;
